import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../assets/images/users/avatar-7.jpg";
import avatar8 from "../../assets/images/users/avatar-8.jpg";
import avatar9 from "../../assets/images/users/avatar-9.jpg";
import avatar10 from "../../assets/images/users/avatar-10.jpg";

import dummyuser from "../../assets/images/users/user-dummy-img.jpg"

const userList = [
    {
        id: 1,
        user_name: "Alfred Hurst",
        user_img: avatar2,
        email_id: "alfredH@toner.com",
        date: "18 Dec, 2018",
        status: "Inactive"
    },
    {
        id: 2,
        user_name: "Tommy Carey",
        user_img: avatar3,
        email_id: "careytommy@toner.com",
        date: "02 Jan, 2023",
        status: "Active"
    },
    {
        id: 3,
        user_name: "Cassius Brock",
        user_img: avatar4,
        email_id: "brock@toner.com",
        date: "24 Nov, 2022",
        status: "Active"
    },
    {
        id: 4,
        user_name: "Camilla Winters",
        user_img: avatar5,
        email_id: "camilla@toner.com",
        date: "12 Jan, 2023",
        status: "Inactive"
    },
    {
        id: 5,
        user_name: "Gabrielle Holden",
        user_img: avatar6,
        email_id: "gabrielle@toner.com",
        date: "17 Nov, 2022",
        status: "Active"
    },
    {
        id: 6,
        user_name: "Kristina Hooper",
        user_img: avatar7,
        email_id: "kristina@toner.com",
        date: "04 Oct, 2020",
        status: "Inactive"
    },
    {
        id: 7,
        user_name: "Jacques Leon",
        user_img: dummyuser,
        email_id: "jacques@toner.com",
        date: "07 Feb, 2015",
        status: "Active"
    },
    {
        id: 8,
        user_name: "Theresa Crawford",
        user_img: avatar8,
        email_id: "crawford@toner.com",
        date: "28 Oct, 2014",
        status: "Active"
    },
    {
        id: 9,
        user_name: "Alina Holland",
        user_img: avatar9,
        email_id: "hollandalina@toner.com",
        date: "16 Aug, 2016",
        status: "Active"
    },
    {
        id: 10,
        user_name: "Edward Rogers",
        user_img: avatar10,
        email_id: "edwardro@toner.com",
        date: "25 Nov, 2021",
        status: "Inactive"
    }
]

export { userList }